import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import AdministratorsList from '../components/AdministratorsList';

// Query for list of administrators for current salon
export const GET_ADMINISTRATORS_QUERY = gql`
    query getAdministrators($salon: ID!) {
        viewer {
            id
            ... on Administrator {
                salon(id: $salon) {
                    id
                    administrators {
                        id
                        firstName
                        lastName
                        phone
                        email
                        roles
                    }
                }
            }
        }
    }
`;

const withData = graphql(GET_ADMINISTRATORS_QUERY, {
    options: ownProps => ({
        variables: {
            salon: ownProps.salon,
            search: ownProps.searchQuery || undefined,
        },
        fetchPolicy: 'cache-and-network',
    }),
    props: ({ data: { viewer, loading, error } }) => ({
        loading,
        administrators: !loading && viewer ? viewer.salon.administrators : [],
    }),
});

const mapStateToProps = ({ staff, user }) => ({
    searchQuery: staff.get('searchQuery'),
    salon: user.get('salon'),
});

export default compose(
    connect(mapStateToProps),
    withData,
)(AdministratorsList);
